module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "flow-triggers"
    }
  }, [_c('div', {
    staticClass: "triggers-integrations"
  }, [_vm._m(0), _vm._l((_vm.matching), function(item, index) {
    return _c('div', {
      staticClass: "row row-trigger"
    }, [(!item._destroy) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row first-item"
    }, [_c('div', {
      staticClass: "line-left"
    }), _c('div', {
      staticClass: "ball"
    }), _vm._m(1, true), _c('div', {
      staticClass: "col-md-3"
    }, [_c('dropdown-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "field",
      attrs: {
        "options": _vm.triggers_options,
        "selected": item.trigger_type
      },
      on: {
        "input": _vm.setDirty
      },
      model: {
        value: (item.trigger_type),
        callback: function($$v) {
          _vm.$set(item, "trigger_type", $$v)
        },
        expression: "item.trigger_type"
      }
    })], 1), (item.trigger_type == 'stage') ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('dropdown-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "field",
      attrs: {
        "options": _vm.stages_options,
        "selected": item.trigger_value
      },
      on: {
        "input": _vm.setDirty
      },
      model: {
        value: (item.trigger_value),
        callback: function($$v) {
          _vm.$set(item, "trigger_value", $$v)
        },
        expression: "item.trigger_value"
      }
    })], 1) : _vm._e(), (item.trigger_type == 'lost') ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('dropdown-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "field",
      attrs: {
        "data-vv-name": "lost_reason_unit",
        "options": _vm.lostReasonOptions()
      },
      model: {
        value: (item.trigger_value),
        callback: function($$v) {
          _vm.$set(item, "trigger_value", $$v)
        },
        expression: "item.trigger_value"
      }
    })], 1) : _vm._e()]), _c('div', {
      staticClass: "row trigger-item",
      class: [_vm.show_timming_actions.indexOf(item.action_type) > -1 ? '' : 'no-border']
    }, [_c('div', {
      staticClass: "line-faker"
    }), _c('div', {
      staticClass: "col-md-2 col-question fake-half-width"
    }), _vm._m(2, true), _c('div', {
      staticClass: "col-md-3"
    }, [_c('dropdown-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "field",
      attrs: {
        "options": item.trigger_type != 'stage' && item.trigger_type != 'lost' ? _vm.actions_options : _vm.actions_trigger_without_stages,
        "selected": item.action_type
      },
      on: {
        "input": _vm.setDirty
      },
      model: {
        value: (item.action_type),
        callback: function($$v) {
          _vm.$set(item, "action_type", $$v)
        },
        expression: "item.action_type"
      }
    })], 1), (item.action_type == 'change_stage') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('dropdown-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "field",
      attrs: {
        "options": _vm.stages_options,
        "selected": item.action_value
      },
      on: {
        "input": _vm.setDirty
      },
      model: {
        value: (item.action_value),
        callback: function($$v) {
          _vm.$set(item, "action_value", $$v)
        },
        expression: "item.action_value"
      }
    })], 1) : _vm._e(), (item.action_type == 'send_to_new_flow') ? _c('div', {
      staticClass: "col-md-4 contact-list-item-flow"
    }, [_c('flows', {
      attrs: {
        "position": index,
        "focus": false,
        "default_flow": item.action_value,
        "user_id": _vm.current_user_id
      },
      on: {
        "flow-selected": _vm.selectFlow
      }
    })], 1) : _vm._e(), (item.action_type == 'fill_property') ? _c('div', {
      staticClass: "col-md-5 no-padding"
    }, [_c('dropdown-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "field fill-property-field",
      attrs: {
        "options": _vm.properties_options,
        "selected": item.action_target
      },
      on: {
        "input": _vm.setDirty
      },
      model: {
        value: (item.action_target),
        callback: function($$v) {
          _vm.$set(item, "action_target", $$v)
        },
        expression: "item.action_target"
      }
    }), _c('div', {
      staticClass: "trigger-question"
    }, [_vm._v("com")]), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (item.action_value),
        expression: "item.action_value"
      }],
      staticClass: "form-control fill-property-field",
      attrs: {
        "name": "name",
        "type": "text"
      },
      domProps: {
        "value": (item.action_value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "action_value", $event.target.value)
        }
      }
    })], 1) : _vm._e(), (item.action_type == 'insert_tag') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('dropdown-multiple-select', {
      attrs: {
        "filter_item_selected_ids": item.action_metadata,
        "position": index,
        "index": index,
        "kind": _vm.kind_multiple_filter
      },
      on: {
        "item-selected-items": _vm.itemSelectedItems
      }
    })], 1) : _vm._e(), (item.action_type == 'insert_into_a_group') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('groups', {
      attrs: {
        "position": index,
        "default_group": item.action_value,
        "user_id": _vm.selected_user
      },
      on: {
        "group-selected": _vm.selectGroup
      }
    })], 1) : _vm._e(), (item.action_type == 'change_responsible') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('dropdown-select', {
      attrs: {
        "options": _vm.users_options,
        "selected": item.action_value
      },
      model: {
        value: (item.action_value),
        callback: function($$v) {
          _vm.$set(item, "action_value", $$v)
        },
        expression: "item.action_value"
      }
    })], 1) : _vm._e(), _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticClass: "btn-icon-remove",
      on: {
        "click": function($event) {
          return _vm.removeTrigger(item, index)
        }
      }
    })])]), (_vm.show_timming_actions.indexOf(item.action_type) > -1) ? _c('div', {
      staticClass: "row trigger-item"
    }, [_c('div', {
      staticClass: "mask"
    }), _c('div', {
      staticClass: "col-md-3 col-question fake-width"
    }), _c('div', {
      staticClass: "col-md-3"
    }, [_c('dropdown-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "field",
      attrs: {
        "options": _vm.timming_options,
        "selected": item.timming_type,
        "disabled": (item.trigger_type == 'connected' || item.trigger_type == 'bounced') && item.action_type == 'change_stage'
      },
      on: {
        "input": _vm.setDirty
      },
      model: {
        value: (item.timming_type),
        callback: function($$v) {
          _vm.$set(item, "timming_type", $$v)
        },
        expression: "item.timming_type"
      }
    })], 1), (item.timming_type == 'after') ? _c('div', {
      staticClass: "col-md-3 inline-options"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (item.timming_value),
        expression: "item.timming_value"
      }],
      staticClass: "form-control input-delay",
      attrs: {
        "name": "name",
        "type": "text"
      },
      domProps: {
        "value": (item.timming_value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "timming_value", $event.target.value)
        }
      }
    }), _c('dropdown-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "field input-delay-options",
      attrs: {
        "options": _vm.timming_complements,
        "selected": item.timming_complement
      },
      on: {
        "input": _vm.setDirty
      },
      model: {
        value: (item.timming_complement),
        callback: function($$v) {
          _vm.$set(item, "timming_complement", $$v)
        },
        expression: "item.timming_complement"
      }
    })], 1) : _vm._e()]) : _vm._e()]) : _vm._e()])
  }), _c('div', {
    staticClass: "row btn-new"
  }, [_c('div', {
    staticClass: "btn btn-clean",
    on: {
      "click": function($event) {
        return _vm.newTrigger()
      }
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('flows.actions.addTrigger')))])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("Gatilhos")]), _c('div', {
    staticClass: "titleized"
  }, [_vm._v("Crie gatilhos personalizados para gerar ações automaticamente de acordo com o seu processo.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 fake-width"
  }, [_c('div', {
    staticClass: "trigger-question"
  }, [_vm._v("Quando um contato for")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1 no-padding-right"
  }, [_c('div', {
    staticClass: "trigger-question"
  }, [_vm._v("Quero")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7faac991!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/triggers.vue
// module id = 1176
// module chunks = 1